import { useAsyncCallback } from '../../../hooks'
import {
  EntityAsyncMultiValuedInfiniteListMoreItems,
  EntityMultiValuedListMoreItem,
} from '../../Entity'
import { MultiValuedList } from '../../MultiValuedList'
import { TextMultiValuedListItem } from '../../TextMultiValuedList'
import { getBuildings } from '../Building.api'

import { getDataItems } from './BuildingAsyncMultiValuedList.utils'

function BuildingAsyncMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = EntityMultiValuedListMoreItem,
  MoreItems = EntityAsyncMultiValuedInfiniteListMoreItems,
  apiParams,
  ...restProps
}) {
  const handleLoadData = useAsyncCallback(params => {
    return getBuildings(null, params)
  }, [])

  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      MoreItems={MoreItems}
      moreItemsProps={{
        apiParams,
        getData: handleLoadData,
        getDataItems,
      }}
    />
  )
}

export default BuildingAsyncMultiValuedList
